module.exports = __webpack_public_path__ + "static/media/doggos.323ae637.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/doggos.mp4
// module id = 71
// module chunks = 0